// Registro del service worker de la PWA (public/worker.js).
//
// El worker no cachea nada: solo existe para que la app sea instalable. Por eso
// no hay flujo de "nueva versión disponible" - cada carga ya trae el bundle
// actual del servidor. Registrar /worker.js en el scope "/" además reemplaza
// cualquier service worker viejo (con caché) que haya quedado instalado.

export function register() {
    if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
        return;
    }

    // El SW no funciona si PUBLIC_URL está en otro origen (p. ej. un CDN).
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
        return;
    }

    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register(`${process.env.PUBLIC_URL}/worker.js`, { scope: `${process.env.PUBLIC_URL}/` })
            .catch(error => {
                console.error('Error during service worker registration:', error);
            });
    });
}

export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then(registration => {
                registration.unregister();
            })
            .catch(error => {
                console.error(error.message);
            });
    }
}
